const ContactMethods = () => import('./ContactMethods.vue')
const ContactMethodDetails = () => import('./ContactMethodDetails.vue')

const VisitResults = () => import('./VisitResults.vue')
const VisitResultDetails = () => import('./VisitResultDetails.vue')

export default [
  {
    name: 'contact-methods',
    path: 'contact-methods',
    component: ContactMethods,
    meta: {
      access: ['org.settings.manage', 'org.settings.general.manage']
    },
    children: [
      {
        name: 'contact-method-edit',
        path: ':contactMethodId/edit',
        components: {
          modal: ContactMethodDetails
        },
        meta: {
          showModal: true,
          access: ['org.settings.manage', 'org.settings.general.manage']
        }
      },
      {
        name: 'contact-method-new',
        path: 'new',
        components: {
          modal: ContactMethodDetails
        },
        meta: {
          showModal: true,
          access: ['org.settings.manage', 'org.settings.general.manage']
        }
      }
    ]
  },

  {
    name: 'visit-results',
    path: 'visit-results',
    component: VisitResults,
    meta: {
      access: ['org.visitResult.view']
    },
    children: [
      {
        name: 'visit-result-edit',
        path: ':visitResultId/edit',
        components: {
          modal: VisitResultDetails
        },
        meta: {
          showModal: true,
          access: ['org.visitResult.manage']
        }
      },
      {
        name: 'visit-result-new',
        path: 'new',
        components: {
          modal: VisitResultDetails
        },
        meta: {
          showModal: true,
          access: ['org.visitResult.manage']
        }
      }
    ]
  }
]
